
<!-- <main class="main-container bg-delfi" [class.isMobile]="isMobile">
<mat-toolbar  class="topbar topbar-sticky justify-content-center toolbar-transparent" >
    <img [ngSrc]="logoPath" width="36" height="36" alt="homepage" class="dark-logo logo--brand" priority>
</mat-toolbar>  -->
<div class="container flex-1 align-items-center justify-content-center flex-column d-flex pl--48 pr--48">
    <div class="inner-wrapper">
        <ng-container *ngIf="!showOffer$() && !showDetails$()">
            <ng-container *ngTemplateOutlet="landingContent"></ng-container>
        </ng-container>
        <ng-container *ngIf="showOffer$()">
            <ng-container *ngTemplateOutlet="landingOffer"></ng-container>
        </ng-container> 
        <ng-container *ngIf="showDetails$()">
            <ng-container *ngTemplateOutlet="landingDetails"></ng-container>
        </ng-container>
    </div>

</div>
<!-- </main> -->

<ng-template #landingContent>
<mat-card class="landing-card card-promo card-rounded p--24 text-center d-flex flex-column justify-content-center gap-8 bg-blurred fw"   *ngIf="landingData$()">
    <div [@pushFadeOut]="state" class="pt--lg-24 pt--8">

    
    <div class="h5" [@slideInUp]="{value: '', params: {delay: '100ms'} }" >Abbiamo individuato<br *ngIf="isMobile$()"/> nel bilancio di <br/><b>{{companyData$()?.ragione_sociale}}</b><br/>un {{landingData$().kpiExceedMessage }} </div>
    <div class="text-danger h2  fw-bold mt--" [@slideInUp]="{value: '', params: {delay: '200ms'} }" > {{landingData$().value }}</div>
    <div class="h5" [@slideInUp]="{value: '', params: {delay: '300ms'} }" >in<br/><b> <span class="text-italic">{{ landingData$().kpiName }}</span></b></div>
    <div class="h6" [@slideInUp]="{value: '', params: {delay: '400ms'} }" ><span class="text-italic">{{ landingData$().kpiDescription }}</span></div>
    <div class="cta-scopri mt--32 mat-text-primary h5 fw-bold" [@slideInUp]="{value: '', params: {delay: '500ms'} }" >Puoi ridurre questa spesa<br *ngIf="isMobile$()"/> con la nostra soluzione! </div>
   
    <button mat-flat-button color="primary" class="mt--32 mb--16 rounded p--24" (click)="goToOffer()" [@slideInUp]="{value: '', params: {delay: '600ms'} }" (@slideInUp.done)="toggleStateFlash()" [@pulse]="{value: flash, params: {delay: '700ms'} } ">Scopri come</button>
</div>
<div class="benchmark-block">
    <button (click)="downloadReport()" mat-icon-button color="primary" class="rounded p--24" [@slideInUp]="{value: '', params: {delay: '800ms'} }">Scarica benchmark light</button>
</div>
</mat-card>
</ng-template>

<ng-template #landingOffer>
    <mat-card class="landing-card card-promo card-rounded p--24 text-center d-flex flex-column gap-8" >
        
       <div class="h6 text-primary title-flash" [class.fw-bold]="flash" [@slideInUp]="{value: '', params: {delay: '100ms'} }" (@slideInUp.done)="toggleStateFlash()" [class.active]="flash === 'active'" [@pulsegrow]="{value: flash, params: {delay: '500ms'} }" [attr.title]="'La soluzione è semplice'">La soluzione è semplice</div>
       <ng-container *ngIf="landingData$()?.product">
        <div class="h5" [@slideInUp]="{value: '', params: {delay: '2200ms'} }"><b>{{ landingData$()?.product.product_name }}</b></div>
        <div class="product-image" [@slideInUp]="{value: '', params: {delay: '2300ms'} }" *ngIf="landingData$()?.product"> 
            <img [ngSrc]="landingData$()?.product.image_url" width="580" height="300" [attr.alt]="'products-overview'" class="img-fluid img-responsive rounded product-overview" priority></div>
        <div class="product-description pb--24" [@slideInUp]="{value: '', params: {delay: '2500ms'} }"  *ngIf="landingData$()?.product">{{landingData$()?.product.short_description }}</div>
       </ng-container>
       <div class="actions d-flex flex-column gap-8">
        <div class="d-flex align-items-center gap-8 justify-content-center">
            <ng-container *ngIf="landingData$()?.product && landingData$()?.product?.purchase_method !== 'contract'; else noContract">
                <button mat-flat-button color="primary" class="rounded p--24 col-6" [@slideInUp]="{value: '', params: {delay: '2500ms'} }" (click)="loginAndBuy(landingData$()?.product.product_sku)">Acquista</button>
                <!-- <button mat-stroked-button color="primary" class="rounded p--24 col-12 flex-1" [@slideInUp]="{value: '', params: {delay: '2600ms'} }">Voglio pi&ugrave; informazioni</button> -->
                
                <app-button-contact [product]="productContactInfo$()"  class="flex-1" [contactInfo]="userContactInfo$()" [wrapperclass]="responsiveClass$()" buttonType="stroked" [buttonclass]="['rounded','col-12']" [buttonlabel]="'Voglio più informazioni'" [@slideInUp]="{value: '', params: {delay: '2600ms'} }"></app-button-contact>
            </ng-container>
            <ng-template #noContract>
                <!-- <button mat-flat-button color="primary" class="rounded p--24 col-12" [@slideInUp]="{value: '', params: {delay: '550ms'} }">Voglio pi&ugrave; informazioni</button> -->
                <app-button-contact [product]="productContactInfo$()" [contactInfo]="userContactInfo$()" [wrapperclass]="responsiveClass$()" class="fw" [buttonclass]="['rounded','col-12',]" [buttonfw]="true" [buttonlabel]="'Voglio più informazioni'" [@slideInUp]="{value: '', params: {delay: '2600ms'} }"></app-button-contact>
            </ng-template>
            <!-- <ng-container *ngIf="main_product?.product_price">
            </ng-container> -->
            <!-- <button mat-stroked-button color="primary" class="rounded p--24" (click)="goToDetails()">Scopri di pi&ugrave;</button> -->
        </div>
        <div class="fs-14" [@slideInUp]="{value: '', params: {delay: '2650ms'} }">Inoltre puoi</div>
        <div class="d-flex align-items-center gap-8 justify-content-center">
            <button mat-flat-button color="accent" class="rounded p--24 flex-1" [@slideInUp]="{value: '', params: {delay: '2700ms'} }" (click)="goToPlatform('marker')">Misurare la tua efficacia digitale</button>
            <button mat-flat-button color="accent" class="rounded p--24 flex-1" [@slideInUp]="{value: '', params: {delay: '2800ms'} }" (click)="goToPlatform('obiettivoeuropa')">Ottenere fondi pubblici</button>
        </div>
       </div>
    </mat-card>
</ng-template>


<ng-template #landingDetails>
    <mat-card class="landing-card card-promo card-rounded p--24 d-flex flex-column gap-8" [@pullFadeIn]>
        <mat-card-header>
            <div mat-card-avatar class="product-header-image">
                <img [ngSrc]="landingMainProduct?.thumb_url" width="80" height="80" [attr.alt]="'products-overview'" priority class="img-responsive">
            </div>
            <mat-card-title class="mb--0">{{ landingData$()?.product.product_name }}</mat-card-title>
          </mat-card-header>
       <div class="product-description flex-1">
            <div class="product_suggestion_question"><b>Cosa dovresti fare</b></div>
            <div class="product_suggestion_answer bg-gradient-2 rounded p--16 mb--16" [innerHTML]="landingData$()?.product.descrizione_suggerimento"></div>
            <div class="product_suggestion_question"><b>Come risolve il problema</b></div>
            <div class="product_suggestion_answer bg-gradient-4 rounded p--16 mb--16" [innerHTML]="landingData$()?.product.descrizione_azione"></div> 
            <div class="product_price_title"><b>Quanto ti costa</b></div>
            <div class="product_price  bg-color-gradient-2 rounded p--16" >
                <ng-container *ngIf="landingData$()?.product?.product_price; else noProductPrice">
                    {{ landingData$()?.product.product_price | currency:'EUR':'symbol':'1.2-2' }}
                </ng-container>
                <ng-template #noProductPrice>
                    Paghi solo se ottieni il beneficio
                </ng-template>
            </div>   
        </div>
       <div class="actions">
        <div class="grid-actions">
            <button mat-flat-button color="primary" class="rounded p--24" >Acquista</button>
            <button mat-stroked-button color="primary" class="rounded p--24" >Contatta un consulente</button>
        </div>
        </div>
       </mat-card>
    </ng-template>


<ng-template #landingFooter>
    <div class="footer-container footer-bg">
        <app-footer-standalone></app-footer-standalone>
    </div>
</ng-template>


